"use strict";
import { defaultBaseConfig } from './preset-base.js';
import { createSystem } from './styled-system/system.js';
import { defaultThemeConfig } from './theme/index.js';
import { mergeConfigs } from './styled-system/merge-config.js';

const defaultConfig = mergeConfigs(defaultBaseConfig, defaultThemeConfig);
const defaultSystem = createSystem(defaultConfig);

export { defaultConfig, defaultSystem, defaultSystem as system };
